import { Zone } from '@/types/zones.types';
import { atom } from 'recoil';

export const zonesAtom = atom({
  key: "zonesAtom",
  default: undefined as Zone[] | undefined,
})
